import React from 'react';

export const MatchMessageCardflagLabel = (info: string | null, icon: React.ReactNode) => {
  if (!info) return <></>;

  return (
    <li className="inline-flex rounded-lg space-x-1.5 items-center flex-shrink-0">
      {icon}
      <span className="text-xxs font-semibold uppercase tracking-wide">{info}</span>
    </li>
  );
};
